module.exports = __webpack_public_path__ + "static/media/service-8.7af42db6.svg";